import { AlertCircleIcon } from 'lucide-react';
import { Alert, AlertAction, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { useI18n } from '@/lib/i18n';

export function PageLoading() {
  const { t } = useI18n();
  return (
    <div className="flex items-center justify-center gap-2 py-16 text-muted-foreground" role="status">
      <Spinner /> {t('loading')}
    </div>
  );
}

export function ErrorState({ text, onRetry }: { text: string; onRetry?: () => void }) {
  const { t } = useI18n();
  return (
    <Alert variant="destructive">
      <AlertCircleIcon />
      <AlertDescription>{text}</AlertDescription>
      {onRetry ? (
        <AlertAction>
          <Button size="sm" variant="outline" onClick={onRetry}>
            {t('retry')}
          </Button>
        </AlertAction>
      ) : null}
    </Alert>
  );
}
